module.exports = __webpack_public_path__ + "img/tour-58.1c09bde2.png";